module.exports = __webpack_public_path__ + "static/media/add_user_icon.993d987d.svg";